// extracted by mini-css-extract-plugin
export var calculatedBadge = "_ws-8";
export var container = "_ws-0";
export var radioDot = "_ws-5";
export var radioDotSelected = "_ws-6";
export var row = "_ws-1";
export var rowFirst = "_ws-2";
export var rowLast = "_ws-3";
export var rowSelected = "_ws-4";
export var strikethrough = "_ws-7";